const phone = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="m11.3 8.915-1.605 1.592a.493.493 0 0 1-.457.132C7.174 10.15 5.896 8.885 5.405 6.84a.484.484 0 0 1 .132-.453L7.143 4.79 3.397 1.075a.597.597 0 0 0-.832 0L.435 3.188c-.361.356-.511.872-.398 1.364 1.48 6.139 5.315 9.943 11.504 11.411a1.483 1.483 0 0 0 1.379-.398l2.13-2.114a.585.585 0 0 0 0-.826z"/></svg>',
};

export { phone as default };
